import React, { Fragment, useEffect } from 'react';
import { Helmet } from "react-helmet";
import MastheadDemo from '../components/MastheadDemo/MastheadDemo';
import DemoSteps from '../components/DemoSteps/DemoSteps';
import useAxios from '../utils/hooks/useAxios';
import MobileApp from '../components/MobileApp/MobileApp';
import Disclosure from '../components/Disclosure/Disclosure';
import Footer from '../components/Footer/Footer';
import { Error, IsPending } from '../utils/SiteTools';
import { lobSourceName, lobDemoSplit, defaultMetaDescription } from '../utils/LobLogicModule';

const Demo = ({ match }) => {
  const sourceName = lobSourceName;
  const demoSplit = lobDemoSplit;
  // Appended match props passed from Route to fetch demo data
  const { data, isPending, error } = useAxios(`${process.env.REACT_APP_GCDEV_API_DEMO_DETAIL}${match.params.demoRoute}`+sourceName);
  
  useEffect(() => {
    // Show 'Sing in' on for Demo page
    const loginCTA = document.querySelector('.login-cta');
    loginCTA && loginCTA.classList.remove('hide');

    // Hide 'Sing in' page when going out of Demo page
    return () => loginCTA && loginCTA.classList.add('hide');
  }, []);

  return (
    <Fragment>
      { isPending && <IsPending /> }
      { (error || data?.error) && <Error errorMessage={error || data.error.message} /> }
  
      { (data && !data.error) && <main className={"demo " + data.type.split(" ")[0].toLowerCase() + " " + data.categories.map(category => category === "merchantservices" ? "merchantservices" : "").join("")} data-pageid={match.params.demoRoute} >
        <Helmet>
          <html lang={data.lang + '-US'} />
          <meta name="description" content={`${data.metadata ? data.metadata : defaultMetaDescription}`}/>
        </Helmet>
        <MastheadDemo content={data} pageRoute={match.params.demoRoute} />
        <DemoSteps content={data} />
        <MobileApp />
        <Disclosure disclosures={data.disclosures} />
        <Footer footerMap={(demoSplit === '' || demoSplit === '/fc' ? `MAP5849152, ` : demoSplit === '/ml' || demoSplit === '/privatebank' ? `MAP5432664, ` : ``) + data.mapNumber} />
      </main> }
    </Fragment>
  )
}

export default Demo;